import {TS} from "../../../../../../type/ts";
import {TraceIdentifiersVisitorOptions} from "../trace-identifiers-visitor-options";

/**
 * Traces identifiers for the given CallExpression.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function traceIdentifiersForCallExpression(_options: TraceIdentifiersVisitorOptions<TS.CallExpression>): void {
	// Do nothing
}
